import { useState, useEffect } from "react";
import api from "@/lib/api";

const cache = {};

export const useSite = (page, lang = "en") => {
  const ck = `${page}:${lang}`;
  const [data, setData] = useState(cache[ck] || null);
  useEffect(() => {
    if (cache[ck]) { setData(cache[ck]); return; }
    api.get(`/site/${page}?lang=${lang}`).then((r) => { cache[ck] = r.data; setData(r.data); }).catch(() => {});
  }, [page, lang, ck]);
  const g = (k, fb) => data?.content?.[k] || fb;
  const s = (k, fb) => data?.shell?.[k] || fb;
  return { g, s, brand: data?.brand || {}, seo: data?.seo || null, loaded: !!data };
};

export const MKT_LANGS = ["es", "pt", "fr"];

export const renderHl = (text) => {
  if (!text || typeof text !== "string") return text;
  return text.split(/(\*\*[^*]+\*\*|~~[^~]+~~)/g).map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) return <span key={i} className="text-[#0071E3]">{p.slice(2, -2)}</span>;
    if (p.startsWith("~~") && p.endsWith("~~")) return <span key={i} className="text-[#86868B]">{p.slice(2, -2)}</span>;
    return p;
  });
};

export const maybeRedirectToLang = (route = "/", subpath = "") => {
  try {
    if (window.location.pathname !== route) return false;
    const params = new URLSearchParams(window.location.search);
    if (params.get("lang") === "en") { localStorage.setItem("mkt_lang_choice", "en"); return false; }
    if (localStorage.getItem("mkt_lang_choice") === "en") return false;
    if (route === "/" && localStorage.getItem("agi_token")) { window.location.replace("/app"); return true; }
    const lang = (navigator.language || "en").slice(0, 2).toLowerCase();
    if (MKT_LANGS.includes(lang)) {
      window.location.replace(`/${lang}/${subpath}`);
      return true;
    }
  } catch (e) { /* noop */ }
  return false;
};
